<template>
  <!--交通巡查-->
  <div class="flex-1 center-bottom">
    <div class="flex flex-column flex-center dashboard-pie-item">
      <div id="dashboardPie1" class="pie-box flex-1"></div>
      <h2 class="center-bottom-title">日度</h2>
    </div>
    <div class="flex flex-column flex-center dashboard-pie-item">
      <div id="dashboardPie2" class="pie-box flex-1"></div>
      <h2 class="center-bottom-title">月度</h2>
    </div>
    <div class="flex flex-column flex-center dashboard-pie-item">
      <div id="dashboardPie3" class="pie-box flex-1"></div>
      <h2 class="center-bottom-title">季度</h2>
    </div>
    <div class="flex flex-column flex-center dashboard-pie-item">
      <div id="dashboardPie4" class="pie-box flex-1"></div>
      <h2 class="center-bottom-title">年度</h2>
    </div>
    <div class="flex flex-column flex-center dashboard-pie-item">
      <div id="dashboardPie5" class="pie-box flex-1"></div>
      <h2 class="center-bottom-title">累计</h2>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import resize from "@/utils/resize";
import { optionConfigFn1 } from "./dashboardPieConfig1";
export default {
  mixins: [resize],
  props: {
    data: {
      default: () => null,
      type: Object,
    },
    refresh: {
      default: () => null,
      type: Number,
    },
  },
  data() {
    return {
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
    };
  },
  watch: {
    refresh: {
      handler() {
        if (this.refresh === 0) return;
        this.renderChart();
      },
      immidiate: true,
    },
  },
  methods: {
    renderChart() {
      // let that = this;
      this.chart1 = echarts.init(document.getElementById("dashboardPie1"));
      const option1 = optionConfigFn1(echarts, this.data.dailyCount, "条");
      this.chart1.setOption(option1);

      this.chart2 = echarts.init(document.getElementById("dashboardPie2"));
      const option2 = optionConfigFn1(
        echarts,
        this.convertToThousandths(this.data.monthlyCount),
        "万条"
      );
      this.chart2.setOption(option2);

      this.chart3 = echarts.init(document.getElementById("dashboardPie3"));
      const option3 = optionConfigFn1(
        echarts,
        this.convertToThousandths(this.data.quarterlyCount),
        "万条"
      );
      this.chart3.setOption(option3);

      this.chart4 = echarts.init(document.getElementById("dashboardPie4"));
      const option4 = optionConfigFn1(
        echarts,
        this.convertToThousandths(this.data.yearlyCount),
        "万条"
      );
      this.chart4.setOption(option4);

      this.chart5 = echarts.init(document.getElementById("dashboardPie5"));
      const option5 = optionConfigFn1(
        echarts,
        this.convertToThousandths(this.data.totalCount),
        "万条"
      );
      this.chart5.setOption(option5);
    },
    //数字转换为万
    convertToThousandths(value) {
      return (value / 10000).toFixed(2); // 将数字除以10000，并保留两位小数
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/variable";
.pie-box {
  background: url($oss-url + "CorrosionMonitorScreen/dashboard-pie.png")
    no-repeat center center/contain;
}
.center-bottom {
  display: grid;
  grid-template-columns: repeat(5, 20%);
  padding: calc(100vh / 1080 * 10) calc(100vw / 1920 * 50)
    calc(100vh / 1080 * 40) calc(100vw / 1920 * 50);

  &-title {
    text-align: center;
    color: #fff;
    font-size: calc(100vw / 1920 * 18);
    font-weight: 600;
  }
  .dashboard-pie-item {
    padding: 0 calc(100vw / 1920 * 10);
  }
}
</style>
